document.addEventListener('DOMContentLoaded', () => {

    function isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    const csFilterSearchInput = document.querySelector('#csFilterSearchInput')
    const csFilterSearchContainer = document.querySelector('#csFilterSearchContainer')

    const csEvents = ['input', 'paste'];
    let csDebounceTimeout;

    csEvents.forEach(event => {
        csFilterSearchInput.addEventListener(event, () => {
        clearTimeout(csDebounceTimeout);
        csDebounceTimeout = setTimeout(() => {
            csSearchFunction();
        }, 100);
      });
    });

    async function csSearchFunction() {
    if (csFilterSearchInput.value !== '') {
      try {
        csFilterSearchContainer.innerHTML = `Loading...`;
  
        // Define all fetch requests
        const searchRequest = fetch(
          window.Shopify.routes.root + `search/suggest.json?q=${csFilterSearchInput.value}&resources[type]=product,collection`
        );
        const inventoryRequest = fetch(
          window.Shopify.routes.root + `products/${csFilterSearchInput.value}/?view=json`
        );
  
        // Wait for all fetch requests to resolve
        const [searchResponse, inventoryResponse] = await Promise.all([
          searchRequest,
          inventoryRequest
        ]);
  
        const suggestions = await searchResponse.json();
        const products = suggestions.resources.results.products;
        const collections = suggestions.resources.results.collections;
  
        let inventoryRes = null;
        if (inventoryResponse.ok) {
          inventoryRes = await inventoryResponse.json();
          console.log("Inventory Response:", inventoryRes);
        } else {
          console.warn(`Skipping inventory: API returned status ${inventoryResponse.status}`);
        }
  
        let div = '';
  
        if (isEmpty(products) && isEmpty(collections) && !inventoryRes) {
          div += `<p>No results found...</p>`;
        } else {
          div += `<div class="cs-grid">`;
  
          // Inventory-based section (if available)
          if (inventoryRes) {
						div += `<a href="${inventoryRes.url}">`;
							div += `<p>Inventory Based</p>`;
							div += `<div class="cs-product">`;
								div += `<div class="cs-image"><img src="${inventoryRes.image}" /></div>`;
								div += `<p>${inventoryRes.title}</p>`;
							div += `</div>`;
						div += `</a>`;
          }
  
          // Products Section
          if (!isEmpty(products)) {
            div += `<p><strong>Products</strong></p>`;
            const productPromises = products.map(async (product) => {
              if (product.image && product.title) {
                const productRes = await fetch(
                  window.Shopify.routes.root + `products/${product.handle}/?view=json`
                );
                const res = await productRes.json();
  
                return `
                  <div class="cs-product">
                    <div class="cs-image"><img src="${product.image}" /></div>
                    <p><a href="${product.url}">${product.title}</a></p>                    
                  </div>`;
              }
              return '';
            });
  
            div += (await Promise.all(productPromises)).join('');
          }
  
          // Collections Section
          if (!isEmpty(collections)) {
            div += `<p><strong>Collections</strong></p>`;
            div += collections
              .map(
                (collection) =>
                  `<div class="cs-collection">
                     <p><a href="${collection.url}">${collection.title}</a></p>
                   </div>`
              )
              .join('');
          }
  
          div += `</div>`;
        }
  
        csFilterSearchContainer.innerHTML = div;
      } catch (error) {
        console.error('Error fetching search results:', error);
      }
    } else {
        // csFilterSearchContainer.innerHTML = `No Results`
				csFilterSearchContainer.innerHTML = ``
    }
    }

})